// Copyright 2025, Imprivata, Inc.  All rights reserved.

export const TRANSLATION_ROOT = 'self-service.consent-screens';

// Screen state constants
export const CUSTOMER_NOTICE = 'customer-notice';
export const STATE_SELECTION = 'state-selection';
export const CUSTOMER_CONSENT = 'customer-consent';
export const IMPRIVATA_CONSENT = 'imprivata-consent';

// Document purpose constants
export const DOCUMENT_PURPOSE_BIOMETRIC_CONSENT = 'biometric-consent';
export const DOCUMENT_PURPOSE_BIOMETRIC_NOTICE = 'biometric-notice';

// Document source constants
export const DOCUMENT_SOURCE_CUSTOMER = 'customer';
export const DOCUMENT_SOURCE_IMPRIVATA = 'imprivata';
